/* src/app/webtree-website/seven-day-free-trial-form/seven-day-free-trial-form.component.scss */
.free-trial-form-container {
  box-shadow: 0 4px 63px 0 rgba(0, 0, 0, 0.08);
  width: 90%;
  margin: 0 auto;
  display: flex;
  border-radius: 8px;
}
.free-trial-form-container .trial-form-slider-section {
  width: 35%;
  height: auto;
  padding: 16px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  background-image:
    linear-gradient(
      to bottom,
      #53a9a6,
      #005d63);
  text-align: center;
  color: #fff;
  font-weight: 600;
  line-height: 1.7;
  display: flex;
  align-items: center;
}
.free-trial-form-container .trial-form-slider-section .parot-green {
  color: #bdffb2;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 20px;
  line-height: 1.7;
}
.free-trial-form-container .trial-form-slider-section .separator {
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  margin-bottom: 20px;
  height: 1px;
}
.free-trial-form-container .trial-form-slider-section .slider-container {
  width: 80%;
  margin: 0 auto;
}
.free-trial-form-container .trial-form-slider-section .slider-container .carousel-control-prev,
.free-trial-form-container .trial-form-slider-section .slider-container .carousel-control-next {
  height: 30px;
  top: 100%;
  opacity: 1;
  color: #fff;
}
.free-trial-form-container .trial-form-slider-section .slider-container .carousel-control-prev::after,
.free-trial-form-container .trial-form-slider-section .slider-container .carousel-control-next::after {
  color: #ffffff;
  font-size: 14px;
}
.free-trial-form-container .trial-form-slider-section .slider-container .carousel-item {
  width: 100%;
  padding-left: 0;
}
.free-trial-form-container .trial-form-slider-section .slider-container .carousel-indicators {
  bottom: -50px;
}
.free-trial-form-container .trial-form-slider-section .slider-container .carousel-indicators li.active {
  background-color: #fff !important;
  opacity: 1;
}
.free-trial-form-container .trial-form-section {
  width: 65%;
  padding: 20px;
  color: #484b59;
}
.free-trial-form-container .trial-form-section .wc-form-control {
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  height: auto;
  padding: 6px 8px;
}
.free-trial-form-container .trial-form-section .input-form-number-box {
  display: flex;
  justify-content: space-between;
}
.free-trial-form-container .trial-form-section .input-form-number-box .phone-number-container {
  width: 75%;
  display: flex;
}
.free-trial-form-container .trial-form-section .input-form-number-box .phone-number-container .country-box {
  width: 100px;
  margin-right: 16px;
}
.free-trial-form-container .trial-form-section .input-form-number-box .phone-number-container .phone-number-box {
  width: calc(100% - 140px);
}
.free-trial-form-container .trial-form-section .input-form-number-box .btn-form-submit {
  padding: 7px 12px;
  border-radius: 3px;
  border: none;
  outline: none;
  color: #ffffff;
  font-size: 14px;
}
.free-trial-form-container .trial-form-section .input-form-number-box .btn-form-submit.btn-disable {
  background-color: #969696;
}
.free-trial-form-container .trial-form-section .input-form-number-box .btn-form-submit.btn-active {
  background-color: #2e93a1;
}
.free-trial-form-container .trial-form-section .input-form-number-box .iti .form-control {
  border: 1px solid #d9d9d9 !important;
  border-radius: 3px !important;
  height: 31px !important;
  width: calc(100% - 135px) !important;
}
.free-trial-form-container .trial-form-section .input-form-number-box .posrelativeinmobile {
  position: absolute;
}
.free-trial-form-container .trial-form-section .input-form-linkedin-box {
  display: flex;
  justify-content: space-between;
}
.free-trial-form-container .trial-form-section .input-form-linkedin-box .linkedinbox {
  width: 75%;
}
.free-trial-form-container .trial-form-section .input-form-linkedin-box .btn-form-submit {
  padding: 7px 12px;
  border-radius: 3px;
  border: none;
  outline: none;
  color: #ffffff;
  font-size: 14px;
}
.free-trial-form-container .trial-form-section .input-form-linkedin-box .btn-form-submit.btn-disable {
  background-color: #969696;
}
.free-trial-form-container .trial-form-section .input-form-linkedin-box .btn-form-submit.btn-active {
  background-color: #2e93a1;
}
@media screen and (max-width: 912px) {
  .free-trial-form-container {
    width: 100%;
    flex-direction: column;
  }
  .free-trial-form-container .trial-form-slider-section {
    width: 100%;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 0px;
  }
  .free-trial-form-container .trial-form-slider-section .slider-container {
    display: none;
  }
  .free-trial-form-container .trial-form-slider-section .separator {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .free-trial-form-container {
    width: 100%;
    flex-direction: column;
  }
  .free-trial-form-container .trial-form-slider-section {
    width: 100%;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 0px;
  }
  .free-trial-form-container .trial-form-slider-section .slider-container {
    display: none;
  }
  .free-trial-form-container .trial-form-slider-section .separator {
    display: none;
  }
}
@media screen and (max-width: 480px) {
  .free-trial-form-container {
    width: 100%;
    flex-direction: column;
  }
  .free-trial-form-container .trial-form-slider-section {
    width: 100%;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 0px;
    display: none;
  }
  .free-trial-form-container .trial-form-slider-section .slider-container {
    display: none;
  }
  .free-trial-form-container .trial-form-slider-section .separator {
    display: none;
  }
  .free-trial-form-container .trial-form-section {
    width: 100%;
  }
  .free-trial-form-container .trial-form-section .input-form-number-box {
    flex-direction: column;
  }
  .free-trial-form-container .trial-form-section .input-form-number-box .phone-number-container {
    width: 100%;
    margin-bottom: 10px;
  }
  .free-trial-form-container .trial-form-section .input-form-number-box .phone-number-container .phone-number-box {
    width: calc(100% - 117px);
  }
  .free-trial-form-container .trial-form-section .input-form-number-box .btn-form-submit {
    width: 100%;
  }
  .free-trial-form-container .trial-form-section .input-form-number-box .iti .form-control {
    border: 1px solid #d9d9d9 !important;
    border-radius: 3px !important;
    height: 31px !important;
    width: 100% !important;
    margin-bottom: 15px !important;
  }
  .free-trial-form-container .trial-form-section .input-form-number-box .posrelativeinmobile {
    position: relative;
  }
  .free-trial-form-container .trial-form-section .input-form-linkedin-box {
    display: flex;
    flex-direction: column;
  }
  .free-trial-form-container .trial-form-section .input-form-linkedin-box .linkedinbox {
    width: 100%;
    margin-bottom: 35px;
  }
  .free-trial-form-container .trial-form-section .input-form-linkedin-box .btn-form-submit {
    width: 100%;
  }
}
.img-success {
  width: 50px;
  height: 50px;
}
.green-color {
  color: #229300;
}
.btn-trms-small {
  border-color: #2e93a1 !important;
}
.btn-trms-small-regular {
  padding: 7px 21px;
  border: 1px solid #2e93a1;
  color: #2e93a1;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1;
  background-color: #ffffff;
  height: 35px;
  min-width: 117px;
}
/*# sourceMappingURL=seven-day-free-trial-form.component-YKBGF3JS.css.map */
